<template>
  <div class="main">
    <div class="left">
      <div class="left_title">
        字典分类
      </div>
      <Navbar></Navbar>
    </div>
    <div class="right">
      <div class="right_title">
        数据字典
      </div>
      <div class="right_function">
        <!-- <Input
          enter-button
          :clearable="true"
          placeholder="请输入搜索内容"
          style="width:220px;"
          v-model="searchData"
          @on-enter="searchBtn"
        /> -->
        <div></div>
        <div>
          <Modal
            msg="新增"
            icon="md-add"
          ></Modal>
          <Modal
            msg="编辑"
            icon="ios-create"
            :handleSelectData="currentRow"
          ></Modal>
          <Modal
            msg="删除"
            icon="md-trash"
            :handleSelectData="currentRow"
          ></Modal>
          <Modal
            msg="字典分类"
            icon="md-settings"
          ></Modal>
        </div>
      </div>
      <el-table
        ref="singleTable"
        :data="this.$store.state.treeList"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width: 100%"
        stripe
      >
        <el-table-column
          label="序号"
          type="index"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="detailname"
          label="项目名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="detailvalue"
          label="项目值"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="seqno"
          label="排序"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="isenable"
          label="有效"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              :disabled="true"
              v-model="scope.row.isenable==1?scope.row.isenable=true:scope.row.isenable=false"
              active-color="#7ed6df"
              inactive-color="#ff7979"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          property="description"
          label="备注"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>
<script>
import Api from '../../api/index'
import Navbar from '../../components/dictionarymenu'
import Modal from '../../components/dictionarymodal'

export default {
  data () {
    return {
      searchData: '',
      tableData: [],
      currentRow: null,
      switchValue: false

    }
  },
  components: {
    Navbar,
    Modal
  },
  created () {

  },
  mounted () {

  },

  methods: {
    //搜索按钮
    searchBtn () {
      console.log(this.searchData);
    },
    //表格选中项
    handleCurrentChange (val) {
      this.currentRow = val;
    },


  },
}
</script>
<style lang='less' scoped>
.main {
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  .left,
  .right {
    border: 1px solid #f0eeff;
    border-radius: 3px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  }
  .left {
    width: 12%;
    height: 100%;
    background-color: #fff;
    .left_title {
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 15px;
      font-weight: 600;
      color: #fff;
      background-color: #1874cd;
    }
  }
  .right {
    width: 87%;
    height: 100%;
    background-color: #fff;
    .right_function {
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
    }
    .right_title {
      color: #666;
      font-size: 15px;
      font-weight: 600;
      border-bottom: 1px solid #c7ebf3;
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
    }
  }
}
</style>